import { defaultTransformer } from "../utils/utils"
import { apiClient } from "./apiClient"

export const settingsApi = {
    fetchSettings: async (businessEntityId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/settings`
        return await apiClient(url, accessToken, { method: "GET" }, defaultTransformer)
    },

    updateSettings: async (businessEntityId, settings, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/settings`
        return await apiClient(url, accessToken, {
            method: "POST",
            headers: { "X-HTTP-Method-Override": "PUT" },
            body: JSON.stringify(settings)
        }, defaultTransformer)
    }
}
